import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = ({ onNavigate, currentView }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', view: 'home' },
    { label: 'About Us', view: 'about' },
    { label: 'Contact Us', view: 'contact' },
    { label: 'Gallery', view: 'gallery' },
  ];

  const handleNavLinkClick = (e, link) => {
    e.preventDefault();
    setMenuOpen(false);

    if (link.view) {
      onNavigate(link.view);

      // If there's a hash, we might need to scroll after the view changes
      if (link.hash) {
        if (currentView === 'home') {
          const element = document.querySelector(link.hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        } else {
          // If coming from another view, wait for Home to render then scroll
          setTimeout(() => {
            const element = document.querySelector(link.hash);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 100);
        }
      }
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__inner container">
        {/* Logo on the left */}
        <div
          onClick={() => onNavigate('home')}
          className="navbar__logo"
          style={{ cursor: 'pointer' }}
        >
          <span className="navbar__logo-icon">📷</span>
          <div className="navbar__logo-group">
            <span className="navbar__logo-text">Shree</span>
            <span className="navbar__logo-sub">Photos</span>
          </div>
        </div>

        {/* Links in the middle */}
        <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.hash || '#'}
                onClick={(e) => handleNavLinkClick(e, link)}
                className={currentView === link.view ? 'active' : ''}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className={`navbar__hamburger ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
